import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Card, Tabs, Spin, message, Timeline, Avatar, Typography, Space, Button, Tooltip, Row, Col, ConfigProvider } from "antd";
import { ProTable } from "@ant-design/pro-table";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import config from "../../../config";
import LoginLogs from "./LoginLogs";
import ActivityTimeline from "../../../components/ActivityLogs";
import enUS from 'antd/lib/locale/en_US';


const { TabPane } = Tabs;
const { Text } = Typography;

const ActivityLogsPage = () => {
  const [activityLog, setActivityLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const environment = window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchActivityLogs();
  }, []);

  const fetchActivityLogs = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/activity-log`);
      setActivityLog(data);
    } catch (err) {
      message.error("Failed to fetch activity logs");
    } finally {
      setLoading(false);
    }
  };

  // Export CSV
  const exportToCSV = () => {
    if (!activityLog.length) return message.warning("No data to export");
    const headers = ["Timestamp", "User", "Title", "Description"];
    const rows = activityLog.map(log => [
      dayjs(log.timestamp).format("YYYY-MM-DD HH:mm:ss"),
      log.user_name,
      log.title,
      log.action,
    ]);
    const csvContent = [headers, ...rows].map(row => row.join(",")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `activity_logs_${dayjs().format("YYYYMMDD_HHmmss")}.csv`);
    message.success("CSV exported");
  };

  // Export PDF
  const exportToPDF = () => {
    if (!activityLog.length) return message.warning("No data to export");
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Timestamp", "User", "Title", "Description"]],
      body: activityLog.map(log => [
        dayjs(log.timestamp).format("YYYY-MM-DD HH:mm:ss"),
        log.user_name,
        log.title,
        log.action,
      ]),
    });
    doc.save(`activity_logs_${dayjs().format("YYYYMMDD_HHmmss")}.pdf`);
    message.success("PDF exported");
  };

  // ProTable columns
  const columns = [
    { title: "Timestamp", dataIndex: "timestamp", valueType: "dateTime", sorter: true, width: 160 },
    { title: "User", dataIndex: "user_name", sorter: true, width:100 },
    { title: "Title", dataIndex: "title", sorter: true, width:200 },
    { title: "Description", dataIndex: "action", ellipsis: true, sorter: true },
  ];

  return (
    <>
    <Card title="Activity Logs">
      <Tabs defaultActiveKey="timeline">
        <TabPane tab="Activity Timeline" key="timeline">
          <Row className="btn-page">
          <Col md="12">
              {/* <Card title="Last 100 Logs" isOption> */}
              {loading ? (
                <div className="text-center align-items-center">
                  <Spin />
                </div>
              ) : (
                <ActivityTimeline activityLog={activityLog} />
              )}
              {/* </Card> */}
            </Col>
            </Row>
        </TabPane>

        <TabPane tab="Activity Table" key="table">
          <ProTable
            columns={columns}
            dataSource={activityLog}
            rowKey="id"
            loading={loading}
            search={false}
            defaultSize="small"
            pagination={{ pageSize: 20, showSizeChanger: true }}
            toolBarRender={() => [
              <Tooltip title="Export CSV"><Button icon={<DownloadOutlined />} onClick={exportToCSV}>CSV</Button></Tooltip>,
              <Tooltip title="Export PDF"><Button icon={<FilePdfOutlined />} onClick={exportToPDF}>PDF</Button></Tooltip>,
            ]}
          />
        </TabPane>

        <TabPane tab="Login Logs" key="login">
          <LoginLogs />
        </TabPane>
      </Tabs>
    </Card>
    </>
  );
};

export default ActivityLogsPage;
